import {
  CircularProgress,
  MenuItem,
  Skeleton,
  TextField,
  Autocomplete,
  Typography,
  createFilterOptions,
} from '@mui/material';
import { renderValueCustomerId } from '../../utils/utils';
import { Controller } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { collection, orderBy, query } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useDispatchProvider } from '../utils/StateProvider';
import { Actions } from '../utils/StateProvider';

const FieldCustomerAutocomplete = ({ control, name, disabled, label, disableClear, setValue, rules, freeSolo }) => {
  const filter = createFilterOptions();
  const dispatch = useDispatchProvider();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const customersDocRef = query(collection(db, 'customers'), orderBy('surname'));

  const [customersSnapshot, loadingRef] = useCollection(customersDocRef);
  // const [customersSnapshot, loading] = useCollectionData(customersDocRef);

  useEffect(() => {
    const fetchCustomers = async () => {
      if (customersSnapshot) {
        const customersData = await Promise.all(
          customersSnapshot.docs.map(async (customerDoc) => {
            const customerData = customerDoc.data();
            return { id: customerDoc.id, ...customerData };
          }),
        );
        setCustomers(customersData);
        setLoading(false);
      }
    };
    // if (ordersSnapshot?.docs.length > 0) {
    //   const lastVisibleDoc = ordersSnapshot.docs[ordersSnapshot.docs.length - 1];
    //   setLastVisible(lastVisibleDoc);
    // }
    setLoading(true);
    fetchCustomers().then();
    // console.log(customersSnapshot);
  }, [customersSnapshot]);

  if (loading)
    return (
      <Skeleton
        variant={'rounded'}
        animation="wave"
        sx={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomStyle: 'solid',
          borderBottomWidth: 1,
          borderBottomColor: 'divider',
        }}
        height={56}
      />
    );
  return (
    // <Controller
    //   name={name}
    //   defaultValue=""
    //   control={control}
    //   rules={rules}
    //   render={({ field }) => (
    //     <TextField
    //       {...field}
    //       label={label}
    //       variant="filled"
    //       fullWidth
    //       disabled={disabled}
    //       select
    //       slotProps={{
    //         input: {
    //           endAdornment:
    //             field.value && !disableClear ? (
    //               <InputAdornment position="end">
    //                 <IconButton
    //                   onClick={() => setValue(field.name, '')}
    //                   edge="end"
    //                 >
    //                   <Clear />
    //                 </IconButton>
    //               </InputAdornment>
    //             ) : null,
    //         },
    //       }}
    //       // slotProps={{
    //       //   input: {
    //       //     endAdornment: !loading ? (
    //       //       <CircularProgress
    //       //         color="inherit"
    //       //         size={24}
    //       //       />
    //       //     ) : null,
    //       //   },
    //       // }}
    //     >
    //       {customersSnapshot?.docs.map((doc) => {
    //         const customerSnap = doc.data();
    //         return (
    //           <MenuItem
    //             key={doc.id}
    //             value={doc.id}
    //           >
    //             {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
    //             <Typography variant="inherit">{renderValueCustomerId(customerSnap)}</Typography>
    //           </MenuItem>
    //         );
    //       })}
    //     </TextField>
    //   )}
    // />
    <Controller
      name={name}
      defaultValue=""
      control={control}
      rules={rules}
      render={({ field }) => {
        const selectedCustomer = customers ? customers.find((customer) => customer.id === field.value) : '';
        // console.log('selectedCustomer', selectedCustomer, customers);
        return (
          <Autocomplete
            freeSolo={freeSolo}
            loading={loading}
            // clearOnBlur={true}
            disabled={disabled}
            disableClearable={disableClear}
            onChange={(event, newValue) => {
              // console.log(newValue);
              if (newValue?.isNew && freeSolo && dispatch) {
                dispatch({
                  type: Actions.Forms,
                  payload: {
                    formCustomer: '',
                    formCustomerPhone: newValue?.phone,
                  },
                });
                dispatch({
                  type: Actions.DialogCustomer,
                  payload: true,
                });
              }
              return field.onChange(newValue ? newValue.id : '');
            }}
            onBlur={(event, newValue) => {
              if (event.target.value === '') {
                field.onChange('');
              }
            }}
            value={selectedCustomer || null}
            options={customers || []}
            autoComplete
            getOptionLabel={(option) => {
              return `${option.phone} - ${option.surname} ${option.name}`;
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);

              const { inputValue } = params;
              // Suggest the creation of a new value
              const isExisting = options.some((option) => inputValue === option.phone);
              if (inputValue !== '' && !isExisting && freeSolo) {
                filtered.push({
                  phone: inputValue,
                  surname: `New customer`,
                  id: 'new-customer',
                  name: '',
                  isNew: true,
                });
              }

              return filtered;
            }}
            renderOption={(props, option) => (
              <MenuItem
                {...props}
                key={option.id}
                value={option.id}
              >
                {/*<ListItemIcon color={option.color}>{option.icon}</ListItemIcon>*/}
                <Typography
                  variant="inherit"
                  component={'div'}
                >
                  {renderValueCustomerId(option)}
                </Typography>
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                variant="filled"
                fullWidth
                disabled={disabled}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                          />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  },
                }}
                // slotProps={{
                //   input: {
                //     endAdornment: !loading ? (
                //       <CircularProgress
                //         color="inherit"
                //         size={24}
                //       />
                //     ) : null,
                //   },
                // }}
              />
            )}
          />
        );
      }}
    />
  );
};

export default FieldCustomerAutocomplete;
